import React, { useEffect } from 'react';
// import Chart from 'chart.js/auto';
import { Chart } from 'chart.js';
import 'chartjs-adapter-date-fns';
import MainLayout from '../../layouts/MainLayout';
import sleepData from './sleepData.json'; // Import sleep pattern data
import './CandleScope.css';

function SleepChart() {
  useEffect(() => {
    const ctx = document.getElementById('sleepChart').getContext('2d');
    new Chart(ctx, {
      type: 'candlestick', // Set the chart type to 'candlestick'
      data: {
        datasets: [{
          label: 'Sleep Patterns',
          data: sleepData.map(entry => ({
            t: new Date(entry.date).getTime(), // Convert date to timestamp
            o: new Date(`${entry.date} ${entry.start_time}`).getTime(), // Use entry.date
            h: new Date(`${entry.date} ${entry.end_time}`).getTime(), // Use entry.date
            l: new Date(`${entry.date} ${entry.start_time}`).getTime(), // Use entry.date
            c: new Date(`${entry.date} ${entry.end_time}`).getTime() // Use entry.date
          })),
          borderColor: 'black',
          borderWidth: 1
        }]
      },
      options: {
        scales: {
          x: {
            type: 'time', // Use 'time' scale for X-axis
            time: {
              unit: 'day'
            },
            title: {
              display: true,
              text: 'Date'
            }
          },
          y: {
            title: {
              display: true,
              text: 'Sleep Duration (hours)'
            }
          }
        }
      }
    });
  }, []);

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>My Sleep Pattern CandleScope</h2>
      </div>
      <canvas id="sleepChart" width="800" height="400"></canvas>
    </MainLayout>
  );
}


export default SleepChart;
